import { Component, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MyDayService } from '../my-day.service';
import { PositionService } from '../position.service';
import { SitePpeComponent } from './site-ppe/site-ppe.component';
import { HeuristicsService } from '../heuristics.service';
import { ActiveWoComponent } from './active-wo/active-wo.component';
import { InspectorInfoComponent } from './inspector-info/inspector-info.component';
import { PositionAssignmentsService } from '../position-assignments.service';
import { ConfirmComponent } from '../shifts/shift-item/confirm/confirm.component';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { MyBranchService } from '../my-branch.service';
import { saveAs } from 'file-saver';
import { Shift } from '../shift';
import { removeTimeFromWorkArea } from 'src/utils';

@Component({
  selector: 'app-my-day',
  templateUrl: './my-day.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./my-day.component.scss']
})
export class MyDayComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public myDayService: MyDayService,
    public positionService: PositionService,
    public heuristicsService: HeuristicsService,
    public positionAssignmentsService: PositionAssignmentsService,
    private router: Router,
    public myBranchService: MyBranchService,
    ) { }


  @Output() updated = new EventEmitter<boolean>();
  siteInfo = [];
  siteArgs = [];
  shiftInfo = [];
  shifts = [];
  days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  req: any[] = [
    {value: 'none', viewValue: 'No special requirement'},
    {value: 'heavy', viewValue: 'Heavy'},
    {value: 'color', viewValue: 'Color'},
    {value: 'excess', viewValue: 'Excess Capacity'}
  ];
  select = this.req[0].value;
  selectedReq = [];
  contacts = [];
  require = 'none';
  refreshTimer: any;
  isAssigned = 1;
  showUpload = Number(localStorage.getItem('clearance')) > 4 ? true : false;
  sitesWithHandout = [];
  workAreaInput = [];

  ngOnInit() {
    this.myDayService.getSitesInfo()
      .subscribe((data) => {
        if (data) {
          this.siteInfo = data;
          this.myBranchService.getSitesWithHandout().subscribe((data2) => {
            this.sitesWithHandout = data2;
            this.compileSiteData();
          });
        }
      });

    this.refreshTimer = setInterval(() => {
      this.myDayService.getSitesInfo()
        .subscribe((data) => {
          if (data) {
            this.siteInfo = data;
            this.myBranchService.getSitesWithHandout().subscribe((data2) => {
              this.sitesWithHandout = data2;
              this.compileSiteData();
            });
          }
        });
    }, 1000 * 60 * 10);
  }

  compileSiteData() {
    this.siteArgs = [];
    this.shiftInfo = [];
    this.shifts = [];
    let counter = 0;
    for (const site of this.siteInfo) {
      if (site.agencyRequirements === '' || site.agencyRequirements === null) { site.agencyRequirements = 'No PPE information available'; }
      if (site.comments === '' || site.comments === null) { site.comments = 'No site specifics available'; }
      site.siteName = site.name;
      site['positions'] = [];
      const tempDate = new Date();
      counter = 0;
      site.daysWork = [site['isSun'], site['isMon'], site['isTues'],
        site['isWed'], site['isThurs'], site['isFri'], site['isSat']];
      for (let i = new Date().getDay() + 1; counter < 8; i++) {
        counter++;
        if (site.daysWork[i] === 1) {
          break;
        }
        if (i === 7) {
          i = 0;
        }
      }
      tempDate.setDate(tempDate.getDate() + counter);
      site.next = this.getNextShift(tempDate, site);
      site.today = this.getShift(site);
      site.nextDB = this.getNextShiftDB(tempDate);
      site.todayDB = this.getShiftDB(site);
      site.showDownload = this.sitesWithHandout.includes(`${site.site}.pdf`);

      const temp = [];
      temp.push(site.site);
      temp.push(site.shift);
      temp.push(site.todayDB);
      temp.push(site.nextDB);
      this.siteArgs.push(temp);
    }
    this.myDayService.getShiftsInfo(JSON.stringify(this.siteArgs))
        .subscribe((siteData) => {
          if (siteData) {
            for (const item of siteData) {
              this.selectedReq[item.id] = this.req[item['requirement']].value;
              if (item.workArea) {
                this.workAreaInput[item.positionId] = removeTimeFromWorkArea(item.workArea);
              }
            }
            this.compileShifts(siteData);
          } else {
            this.isAssigned = 0;
          }
        });
  }

  openActiveWo(index: any) {
    this.heuristicsService.addHeuristic('MyDay', 'Active')
      .subscribe((data) => {});

    this.dialog.open(ActiveWoComponent, {width: '450px', autoFocus: true,
      data: {siteId: this.siteArgs[index][0], name: this.siteInfo[index]['name']}})
        .afterClosed().subscribe(result => {}
    );
  }

  openPPE(site: any[]) {
    this.heuristicsService.addHeuristic('MyDay', 'PPE')
      .subscribe((data) => {});
    this.dialog.open(SitePpeComponent, {width: '600px', autoFocus: true,
    data: { title: 'PPE (' + site['name'] + ')', message: site['agencyRequirements']}})
      .afterClosed().subscribe(result => {}
    );
  }

  openSiteSpecifics(site: any[]) {
    this.heuristicsService.addHeuristic('MyDay', 'Specifics')
      .subscribe((data) => {});
    this.dialog.open(SitePpeComponent, {width: '600px', autoFocus: true,
    data: { title: 'Site Specifics (' + site['name'] + ')', message: site['comments']}})
      .afterClosed().subscribe(result => {}
    );
  }

  onFileSelected(event, site) {
    site.handoutLoading = true;
    const file: File = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('item', file);
      this.myBranchService.uploadSiteHandout(formData, Number(site['site'])).subscribe(res => {
        if (res.status === 'complete') {
          site.handoutLoading = false;
        }
      });
    }
  }

  fileDownload(site) {
    site.handoutLoading = true;
    this.myBranchService.downloadSiteHandout(Number(site['site']), site['name']).subscribe((blob) => {
      if (blob && blob.type === 'application/pdf') {
        saveAs(blob, `Site Requirements-${site['name']}.pdf`);
      } else {
        this.dialog.open(SitePpeComponent, {
          width: '600px', autoFocus: true, data: { title: 'Error - ' + site['name'], message: 'No site handout avaialable'}})
          .afterClosed().subscribe(result => {});
      }
      site.handoutLoading = false;
    });
  }

  openInspectorInfo(item: any) {
    this.dialog.open(InspectorInfoComponent, {width: '600px', autoFocus: true,
      data: { info: item }})
        .afterClosed().subscribe(result => {}
      );
  }

  compileShifts(shifts: any[]) {
    if (shifts.length > 0) {
      let tempShiftHolder = [];
      let tempSite = shifts[0].site;
      let tempShift = shifts[0].shift;
      let tempDate = shifts[0].positionDate;
      for (const s of shifts) {
        if (s.inspectorId === null) {
          s['name'] = 'EMPTY';
        }
        s.isMulti = 0;
        s.isOverflow = 0;
        if (s.site === tempSite && s.shift === tempShift && s.positionDate === tempDate) {
          tempShiftHolder.push(s);
        } else {
          this.shiftInfo.push(tempShiftHolder);
          tempShiftHolder = [];
          tempSite = s.site;
          tempShift = s.shift;
          tempDate = s.positionDate;
          tempShiftHolder.push(s);
        }
      }
      this.shiftInfo.push(tempShiftHolder);
      this.getShiftStatus();
      this.assignShiftsToSite();
    }
  }

  assignShiftsToSite() {
    for (const shft of this.shiftInfo) {
      for (const st of this.siteInfo) {
        if (shft[0].site === st.site) {
          const updatedShft = shft.map(s => ({
            ...s,
            isStartTimeEdit: false,
            startInfo: {
              hours: s.startTime.split(':')[0],
              minutes: s.startTime.split(':')[1]
            },
            isStartTimeLoading: false,
            isEndTimeEdit: false,
            endInfo: {
              hours: s.endTime.split(':')[0],
              minutes: s.endTime.split(':')[1]
            },
            isEndTimeLoading: false,
          }))
          st['positions'].push(updatedShft);
        }
      }
    }
  }

  getShiftStatus() {
    let tempAgcId = 0;
    for (let i = 0; i < this.shiftInfo.length; i++) {
      for (let j = 1; j < this.shiftInfo[i].length; j++) {
        if (this.shiftInfo[i][j].agencyId !== 0) {
          if (tempAgcId === 0) {
            tempAgcId = this.shiftInfo[i][j].agencyId;
          } else {
            if (this.shiftInfo[i][j].positionId === this.shiftInfo[i][j - 1].positionId) {
              this.shiftInfo[i][j - 1].name = 'Multiple Agencies';
              this.shiftInfo[i][j - 1].isMulti = 1;
              this.shiftInfo[i].splice(j, 1);
            } else {
              tempAgcId = this.shiftInfo[i][j].agencyId;
            }
          }
        } else {
          if (this.shiftInfo[i][j].positionId === this.shiftInfo[i][j - 1].positionId) {
            this.shiftInfo[i][j - 1].isOverflow = 1;
            this.shiftInfo[i][j].isOverflow = 1;
          }
        }
      }
    }
    this.getConfirmedShifts();
  }

  getConfirmedShifts() {
    const tempDate: Date = new Date();
    const tempDate2: Date = new Date();
    tempDate.setDate(tempDate.getDate() + 1);
    tempDate2.setDate(tempDate.getDate() + 1);
    this.myDayService.getFutureShifts(this.getDBFormattedDate(tempDate), this.getDBFormattedDate(tempDate2))
      .subscribe((data) => {
        this.checkForConfirmed(data);
      });
  }

  checkForConfirmed(data: any) {
    for (let i = 0; i < this.shiftInfo.length; i++) {
      for (const shift of this.shiftInfo[i]) {
        shift['isConfirmed'] = 0;
        for (const d of data) {
          const dateDiff = Math.ceil((Math.abs(new Date(shift.positionDate).getTime() - new Date(d.positionDate).getTime())) / (1000 * 3600 * 24));
          if (shift.inspectorId === d.inspectorId && dateDiff === 1) {
            shift['isConfirmed'] = 1;
          }
        }
      }
    }
  }

  setRequirement(dayIndex: number, item: any, index: number, siteIndex: number) {
    let require = 0;
    if (this.selectedReq[item.id] === 'heavy') {
      require = 1;
    } else if (this.selectedReq[item.id] === 'color') {
      require = 2;
    } else if (this.selectedReq[item.id] === 'excess') {
      require = 3;
    }
    this.positionService.setRequirement(item.positionId, require).subscribe((data) => {
      this.siteInfo[siteIndex].positions[dayIndex][index].requirement = require;
      // this.ngOnInit();
    });
  }

  setWorkArea(dayIndex: number, id: any, workArea: string, index: number, siteIndex: number) {
    const removedTimeWorkArea = removeTimeFromWorkArea(workArea);
    this.positionService.setWorkArea(id, removedTimeWorkArea)
    .subscribe(() => {
      this.workAreaInput = {
        ...this.workAreaInput,
        [id]: removedTimeWorkArea
      }
      this.siteInfo[siteIndex].positions[dayIndex][index].workArea = removedTimeWorkArea;
      // this.updated.emit(true);
    });
  }

  markOnSite(dayIndex: number, id: any, index: number, siteIndex: number) {
    this.positionAssignmentsService.markOnSite(id).subscribe((data) => {
      // toggle site position
      this.siteInfo[siteIndex].positions[dayIndex][index].onSite = 1 - this.siteInfo[siteIndex].positions[dayIndex][index].onSite;
      // this.ngOnInit();
    });
  }

  markCovid(dayIndex: number, id: any, index: number, siteIndex: number) {
    this.positionAssignmentsService.markCovid(id)
      .subscribe((data) => {
        // toggle site position
        this.siteInfo[siteIndex].positions[dayIndex][index].covid = 1 - this.siteInfo[siteIndex].positions[dayIndex][index].covid;
        // this.ngOnInit();
      });
  }

  compareDates(d1: Date, d2: Date): boolean {
    return d1.getUTCDate() === d2.getUTCDate() && d1.getUTCMonth() === d2.getUTCMonth() && d1.getUTCDay() === d2.getUTCDay();
  }

  confirmShift(dayIndex: number, tempShift: any, tempSite: any, index: number, siteIndex: number) {
    tempSite.start = tempShift.startTime;
    tempSite.end = tempShift.endTime;
    tempSite.name = tempShift.shift;
    const shiftsTimeInfo: Shift[] = [];
    const site = this.siteInfo.find(site => site.site === tempShift.site);
    const { isAM, isPM, isMN, is4, is5, is6 } = site;
    const shiftProps = [isAM, isPM, isMN, is4, is5, is6];
    const shiftLabels = {
      "0": ["c1label", "amStartH", "amStartM", "amEndH", "amEndM"],
      "1": ["c2label", "pmStartH", "pmStartM", "pmEndH", "pmEndM"],
      "2": ["c3label", "mnStartH", "mnStartM", "mnEndH", "mnEndM"],
      "3": ["c4label", "c4StartH", "c4StartM", "c4EndH", "c4EndM"],
      "4": ["c5label", "c5StartH", "c5StartM", "c5EndH", "c5EndM"],
      "5": ["c6label", "c6StartH", "c6StartM", "c6EndH", "c6EndM"],
    };
    const shiftsNotNeeded = shiftProps.reduce((acc, curr, idx) => {
      if (curr === 1) acc.push(idx)
      return acc;
    }, []);

    const addZeroToTimeValue = (v) => v.toString().length === 1 ? `0${v}` : v;

    for (let idx = 0; idx < shiftsNotNeeded.length; idx++) {
      const shiftLabel = shiftLabels[shiftsNotNeeded[idx]];
      const shiftTimeData = new Shift();
      shiftTimeData.name = site[shiftLabel[0]];
      shiftTimeData.start = `${addZeroToTimeValue(site[shiftLabel[1]])}:${addZeroToTimeValue(site[shiftLabel[2]])}`;
      shiftTimeData.end = `${addZeroToTimeValue(site[shiftLabel[3]])}:${addZeroToTimeValue(site[shiftLabel[4]])}`;
      shiftTimeData.positions = site.positions;
      shiftsTimeInfo.push(shiftTimeData);
    }
    this.dialog.open(ConfirmComponent, {
      width: '75%',
      autoFocus: true,
      data: {
        shift: tempSite,
        shifts: shiftsTimeInfo,
        isInspector: true,
        item: tempShift,
        date: tempShift.positionDate,
        startTime: tempShift.startTime,
        endTime: tempShift.endTime,
        source: 0,
        siteId: tempShift.site,
        siteName: tempSite.name
      }
    })
    .afterClosed()
    .subscribe(result => {
      if (result) {
        if (result.result !== 'cancelled') {

          if (dayIndex === 1) {
            const amountOfNextShiftDays = (new Date(this.siteInfo[siteIndex].todayDB).getDate() + 3) - new Date(result.selectedDate).getDate();
            if (amountOfNextShiftDays === 0) { // If the forwarded position is gonna be for tomorrow
              this.siteInfo[siteIndex].positions[1][index].isConfirmed = 1; // remove forwarding option
            }
          } else {
            const nextShiftAndSelectedDateMatch = this.compareDates(new Date(this.siteInfo[siteIndex].nextDB), new Date(result.selectedDate));

            if (nextShiftAndSelectedDateMatch) { // it's the today's shift
              // push today's shift position to next shift positions
              if (this.siteInfo[siteIndex].positions[1]) {
                this.siteInfo[siteIndex].positions[1] = [
                  ...this.siteInfo[siteIndex].positions[1],
                  {
                    ...this.siteInfo[siteIndex].positions[0][index],
                    id: result.id,
                    positionDate: this.siteInfo[siteIndex].nextDB,
                    onSite: 0,
                    covid: 0
                  }
                ];
              } else {
                this.siteInfo[siteIndex].positions[1] = [
                  {
                    ...this.siteInfo[siteIndex].positions[0][index],
                    id: result.id,
                    positionDate: this.siteInfo[siteIndex].nextDB,
                    onSite: 0,
                    covid: 0
                  }
                ];
              }

              this.selectedReq[result.id] = this.req[this.siteInfo[siteIndex].positions[0][index].requirement].value;
              this.workAreaInput[Number(result.id)] = this.siteInfo[siteIndex].positions[0][index].workArea ? removeTimeFromWorkArea(this.siteInfo[siteIndex].positions[0][index].workArea) : this.siteInfo[siteIndex].positions[0][index].workArea;
            }

            // next date + 2 - current date
            const amountOfDays = (new Date(tempShift.positionDate).getDate() + 2) - new Date(result.selectedDate).getDate();
            if (amountOfDays === 0) { // If the forwarded position is gonna be for tomorrow
              this.siteInfo[siteIndex].positions[0][index].isConfirmed = 1; // remove forwarding option
            }
          }

          // this.ngOnInit();
          // this.updated.emit(true);
        }
      }
    });
  }

  openSite(site: any) {
    let nm = site.name;
    if (nm.indexOf('/') > -1) {
      nm = nm.replace(/\//g, '#2F');
      this.router.navigate(['shifts/' + nm]);
    } else {
      this.router.navigate(['shifts/' + nm]);
    }
  }

  getShift(site: any) {
    const tempDate = new Date();
    if (tempDate.getDay() === 0 && site.isSun === 1) {
      return this.getFormattedDate(tempDate) //  + ' (' + this.getStartEndTimes(site) + ')';
    } else if (tempDate.getDay() === 1 && site.isMon === 1) {
      return this.getFormattedDate(tempDate) //  + ' (' + this.getStartEndTimes(site) + ')';
    } else if (tempDate.getDay() === 2 && site.isTues === 1) {
      return this.getFormattedDate(tempDate) // + ' (' + this.getStartEndTimes(site) + ')';
    } else if (tempDate.getDay() === 3 && site.isWed === 1) {
      return this.getFormattedDate(tempDate) // + ' (' + this.getStartEndTimes(site) + ')';
    } else if (tempDate.getDay() === 4 && site.isThurs === 1) {
      return this.getFormattedDate(tempDate) // + ' (' + this.getStartEndTimes(site) + ')';
    } else if (tempDate.getDay() === 5 && site.isFri === 1) {
      return this.getFormattedDate(tempDate) // + ' (' + this.getStartEndTimes(site) + ')';
    } else if (tempDate.getDay() === 6 && site.isSat === 1) {
      return this.getFormattedDate(tempDate) // + ' (' + this.getStartEndTimes(site) + ')';
    }
  }

  getNextShift(date: Date, site: any[]) {
    return this.getFormattedDate(date) // + ' (' + this.getStartEndTimes(site) + ')';
  }

  getShiftDB(site: any) {
    const tempDate = new Date();
    if (tempDate.getDay() === 0 && site.isSun === 1) {
      return this.getDBFormattedDate(tempDate);
    } else if (tempDate.getDay() === 1 && site.isMon === 1) {
      return this.getDBFormattedDate(tempDate);
    } else if (tempDate.getDay() === 2 && site.isTues === 1) {
      return this.getDBFormattedDate(tempDate);
    } else if (tempDate.getDay() === 3 && site.isWed === 1) {
      return this.getDBFormattedDate(tempDate);
    } else if (tempDate.getDay() === 4 && site.isThurs === 1) {
      return this.getDBFormattedDate(tempDate);
    } else if (tempDate.getDay() === 5 && site.isFri === 1) {
      return this.getDBFormattedDate(tempDate);
    } else if (tempDate.getDay() === 6 && site.isSat === 1) {
      return this.getDBFormattedDate(tempDate);
    }
  }

  getNextShiftDB(date: Date) {
    return this.getDBFormattedDate(date);
  }

  getFormattedDate(date: Date) {
    return this.days[date.getDay()] + ', ' + this.months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
  }

  getDBFormattedDate(date: Date) {
    return date.getFullYear() + '-' + ((date.getMonth() + 1 < 10) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' +
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  }

  getStartEndTimes(site: any[]) {
    if (site['shift'] === site['c1label']) {
      return (site['amStartH'] < 10 ? '0' + site['amStartH'] : site['amStartH']) + ':'
      + (site['amStartM'] < 10 ? '0' + site['amStartM'] : site['amStartM']) + '-'
      + (site['amEndH'] < 10 ? '0' + site['amEndH'] : site['amEndH'])
      + ':' + (site['amEndM'] < 10 ? '0' + site['amEndM'] : site['amEndM']);
    } else if (site['shift'] === site['c2label']) {
      return (site['pmStartH'] < 10 ? '0' + site['pmStartH'] : site['pmStartH']) + ':'
      + (site['pmStartM'] < 10 ? '0' + site['pmStartM'] : site['pmStartM']) + '-'
      + (site['pmEndH'] < 10 ? '0' + site['pmEndH'] : site['pmEndH'])
      + ':' + (site['pmEndM'] < 10 ? '0' + site['pmEndM'] : site['pmEndM']);
    } else if (site['shift'] === site['c3label']) {
      return (site['mnStartH'] < 10 ? '0' + site['mnStartH'] : site['mnStartH']) + ':'
      + (site['mnStartM'] < 10 ? '0' + site['mnStartM'] : site['mnStartM']) + '-'
      + (site['mnEndH'] < 10 ? '0' + site['mnEndH'] : site['mnEndH'])
      + ':' + (site['mnEndM'] < 10 ? '0' + site['mnEndM'] : site['mnEndM']);
    } else if (site['shift'] === site['c4label']) {
      return (site['c4StartH'] < 10 ? '0' + site['c4StartH'] : site['c4StartH']) + ':'
      + (site['c4StartM'] < 10 ? '0' + site['c4StartM'] : site['c4StartM']) + '-'
      + (site['c4EndH'] < 10 ? '0' + site['c4EndH'] : site['c4EndH'])
      + ':' + (site['c4EndM'] < 10 ? '0' + site['c4EndM'] : site['c4EndM']);
    } else if (site['shift'] === site['c5label']) {
      return (site['c5StartH'] < 10 ? '0' + site['c5StartH'] : site['c5StartH']) + ':'
      + (site['c5StartM'] < 10 ? '0' + site['c5StartM'] : site['c5StartM']) + '-'
      + (site['c5EndH'] < 10 ? '0' + site['c5EndH'] : site['c5EndH'])
      + ':' + (site['c5EndM'] < 10 ? '0' + site['c5EndM'] : site['c5EndM']);
    } else if (site['shift'] === site['c6label']) {
      return (site['c6StartH'] < 10 ? '0' + site['c6StartH'] : site['c6StartH']) + ':'
      + (site['c6StartM'] < 10 ? '0' + site['c6StartM'] : site['c6StartM']) + '-'
      + (site['c6EndH'] < 10 ? '0' + site['c6EndH'] : site['c6EndH'])
      + ':' + (site['c6EndM'] < 10 ? '0' + site['c6EndM'] : site['c6EndM']);
    }
  }

  setPositionLoading(dayIndex: number, index: number, siteIndex: number, loading: boolean, isStart: boolean = true) {
    if (isStart) {
      this.siteInfo[siteIndex].positions[dayIndex][index].isStartTimeLoading = loading;
    } else {
      this.siteInfo[siteIndex].positions[dayIndex][index].isEndTimeLoading = loading;
    }
  }

  setStartTimeCheck(item: any, dayIndex: number, index: number, siteIndex: number) {
    const start = `${this.pad(Number(item.startInfo.hours))}:${this.pad(Number(item.startInfo.minutes))}`;
    const end = item.endTime;

    this.setPositionLoading(dayIndex, index, siteIndex, true);
    this.positionService.updateStartAndEndTimeForPosition(start, end, item.positionId)
      .subscribe(() => {
        this.siteInfo[siteIndex].positions[dayIndex][index].startTime = `${this.pad(Number(item.startInfo.hours))}:${this.pad(Number(item.startInfo.minutes))}`;
        this.siteInfo[siteIndex].positions[dayIndex][index].isStartTimeEdit = false;
        this.setPositionLoading(dayIndex, index, siteIndex, false);
      },
      (error) => {
        console.log({ error })
        this.siteInfo[siteIndex].positions[dayIndex][index].startInfo.hours = item.startTime.split(':')[0];
        this.siteInfo[siteIndex].positions[dayIndex][index].startInfo.minutes = item.startTime.split(':')[1];
        this.siteInfo[siteIndex].positions[dayIndex][index].isStartTimeEdit = false;
        this.setPositionLoading(dayIndex, index, siteIndex, false);
      })
  }

  resetStartTimeInputs(item: any, dayIndex: number, index: number, siteIndex: number) {
    this.siteInfo[siteIndex].positions[dayIndex][index].isStartTimeEdit = false;
    this.siteInfo[siteIndex].positions[dayIndex][index].startInfo.hours = item.startTime.split(':')[0];
    this.siteInfo[siteIndex].positions[dayIndex][index].startInfo.minutes = item.startTime.split(':')[1];
  }

  onStartTimeChange(item: any, type: 'hours' | 'minutes', dayIndex: number, index: number, siteIndex: number) {
    const value = type === 'hours'
      ? item.startInfo.hours
      : item.startInfo.minutes;

    // Allow empty while typing
    if (value === '') return;

    // Numeric only
    if (!/^\d{1,2}$/.test(value)) {
      this.revertStartOrEndTime(item, type, true, dayIndex, index, siteIndex);
      return;
    }

    const num = Number(value);

    if (type === 'hours' && (num < 0 || num > 23)) {
      this.revertStartOrEndTime(item, type, true, dayIndex, index, siteIndex);
      return;
    }

    if (type === 'minutes' && (num < 0 || num > 59)) {
      this.revertStartOrEndTime(item, type, true, dayIndex, index, siteIndex);
      return;
    }
  }

  setEndTimeCheck(item: any, dayIndex: number, index: number, siteIndex: number) {
    const start = item.startTime;
    const end = `${this.pad(Number(item.endInfo.hours))}:${this.pad(Number(item.endInfo.minutes))}`;

    this.setPositionLoading(dayIndex, index, siteIndex, true, false);
    this.positionService.updateStartAndEndTimeForPosition(start, end, item.positionId)
      .subscribe(() => {
        this.siteInfo[siteIndex].positions[dayIndex][index].endTime = `${this.pad(Number(item.endInfo.hours))}:${this.pad(Number(item.endInfo.minutes))}`;
        this.siteInfo[siteIndex].positions[dayIndex][index].isEndTimeEdit = false;
        this.setPositionLoading(dayIndex, index, siteIndex, false);
      },
      (error) => {
        console.log({ error })
        this.siteInfo[siteIndex].positions[dayIndex][index].endInfo.hours = item.endTime.split(':')[0];
        this.siteInfo[siteIndex].positions[dayIndex][index].endInfo.minutes = item.endTime.split(':')[1];
        this.siteInfo[siteIndex].positions[dayIndex][index].isEndTimeEdit = false;
        this.setPositionLoading(dayIndex, index, siteIndex, false);
      })
  }

  resetEndTimeInputs(item: any, dayIndex: number, index: number, siteIndex: number) {
    this.siteInfo[siteIndex].positions[dayIndex][index].isEndTimeEdit = false;
    this.siteInfo[siteIndex].positions[dayIndex][index].endInfo.hours = item.endTime.split(':')[0];
    this.siteInfo[siteIndex].positions[dayIndex][index].endInfo.minutes = item.endTime.split(':')[1];
  }

  onEndTimeChange(item: any, type: 'hours' | 'minutes', dayIndex: number, index: number, siteIndex: number) {
    const value = type === 'hours'
      ? item.endInfo.hours
      : item.endInfo.minutes;

    // Allow empty while typing
    if (value === '') return;

    // Numeric only
    if (!/^\d{1,2}$/.test(value)) {
      this.revertStartOrEndTime(item, type, false, dayIndex, index, siteIndex);
      return;
    }

    const num = Number(value);

    if (type === 'hours' && (num < 0 || num > 23)) {
      this.revertStartOrEndTime(item, type, false, dayIndex, index, siteIndex);
      return;
    }

    if (type === 'minutes' && (num < 0 || num > 59)) {
      this.revertStartOrEndTime(item, type, false, dayIndex, index, siteIndex);
      return;
    }
  }

  private revertStartOrEndTime(item: any, type: 'hours' | 'minutes', isStart: boolean = true, dayIndex: number, index: number, siteIndex: number) {
    const [h, m] = isStart ? item.startTime.split(':') : item.endTime.split(':');
    if (type === 'hours') {
      if (isStart) {
        this.siteInfo[siteIndex].positions[dayIndex][index].startInfo.hours = h;
      } else {
        this.siteInfo[siteIndex].positions[dayIndex][index].startInfo.minutes = m;
      }
    } else {
      if (isStart) {
        this.siteInfo[siteIndex].positions[dayIndex][index].endInfo.hours = h;
      } else {
        this.siteInfo[siteIndex].positions[dayIndex][index].endInfo.minutes = m;
      }
    }
  }

  private pad(value: number): string {
    return value.toString().padStart(2, '0');
  }

}
